import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';
import { MIN_WIDTH } from 'utils/constants';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 32px;
  min-width: calc(${MIN_WIDTH} + 32px);
  background-color: ${colors.white};
`;

export const HeaderTop = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const HeaderDropdownContainer = styled.div`
  width: 230px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const HeaderLabel = styled.div`
  display: flex;
  font-size: 28px;
  font-weight: 500;
  color: #333333;
  margin-right: 16px;
`;

export const HeaderDescription = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: ${colors.grey5};
  margin-top: 12px;
`;

export const ParentChartContainer = styled.div`
  position: relative;
  display: flex;
  width: 15%;
  min-width: 250px;
  margin-right: 40px;
`;

export const MainChartContainer = styled.div`
  display: flex;
  width: calc(85% - 40px);
  &:first-child {
    width: 100%;
  }
`;

export const MapWrapper = styled.div`
  margin-top: 40px;
  width: 100%;
`;

export const SpendByChartContainer = styled.div`
  display: flex;
  width: 100%;
  min-width: ${MIN_WIDTH};
`;

export const BackButttonContainer = styled.div`
  display: flex;
  justify-content: center;
  position: absolute;
  width: 100%;
  top: 16px;
  margin-left: 24px;
  z-index: 1;
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  background-color: transparent;
  border: 0px;
  font-size: 13px;
  font-weight: bold;
  color: ${colors.grey7};
  text-transform: uppercase;
  cursor: pointer;
`;

export const SecondaryContent = styled.div`
  height: 100%;
  min-width: ${MIN_WIDTH};
  background-color: ${colors.greyBg};
  padding: 32px;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: ${MIN_WIDTH};
  height: auto;
  padding: 24px 32px;
  background-color: ${colors.white};
  margin-bottom: 32px;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
`;

export const YearOnYearContent = styled.div`
  display: flex;
`;

export const YearOnYearChart = styled.div`
  flex: 1;
  margin-top: 24px;
`;

export const TableWidgets = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 12px;
  margin-left: 32px;
`;

export const TableContainer = styled.div`
  width: 748px;
`;

export const YearOnYearWidget = styled.div`
  margin-bottom: 16px;
`;

export const TopDataContent = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 24px;
`;

export const ComparisonWidgetsContainer = styled.div`
  display: flex;
  margin: 40px 0px 32px;
  justify-content: space-between;
`;

export const NoDataContainer = styled.div`
  height: calc(100vh - 96px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
